import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailCategoryComponent } from './detail-category.component';
import { AngularFrameworkModule } from 'sp-office365-framework';
import { TranslateModule } from '@ngx-translate/core';
import { TableTaskModule } from '../../task/table-task/table-task.module';
import { FormioModule } from '@formio/angular';
import { TableTasktemplateModule } from '../../tasktemplate/table-tasktemplate/table-tasktemplate.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
    declarations: [DetailCategoryComponent],
    imports: [
        CommonModule,
        AngularFrameworkModule,
        TranslateModule,
        MatTabsModule,
        MatSnackBarModule,
        MatToolbarModule,
        MatIconModule,
        TableTaskModule,
        FormioModule,
        FormioModule,
        TableTasktemplateModule,
        DragDropModule,
    ],
})
export class DetailCategoryModule {}
